import React, { Component, createRef, useMemo } from "react";
import { withRouter } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import Row from "./Row";
import SummaryRow from "./SummaryRow";
import SummaryRowEnergy from "./SummaryRowEnergy";
import Loader from "./Loader";
import WildCardFilter from "./WildCardFilter";
import NewWildCardFilter from "../../chartTemplates/components/TableComponents/WildCardFilter";
import { EllipsisTooltipText } from "./EllipsisTextWithTooltip";
import { debounce, isEqual } from "lodash";
import styled from "styled-components";
import MoveIcon from "../../../assets/img/column-move-icon.svg";
import LoadingOverlay from "react-loading-overlay";
import "../../../assets/css/table.css";
import { removeAllTags } from "../../../config/utils";
import { sanitizeHtml } from "./SafeHtml";
import { formatCapitalRequestSourceValue } from "../../../utils/capitalRequestLabel";
import { hasAssetDashboardColumnFilter } from "../../assetDashboard/utils";

const Th = styled.th`
    width: ${props => (props.$thStyle.width ? `${props.$thStyle.width} !important` : "auto")};
    max-width: ${props => (props.$thStyle.maxWidth ? `${props.$thStyle.maxWidth} !important` : "auto")};
    min-width: ${props => (props.$thStyle.minWidth ? `${props.$thStyle.minWidth} !important` : "auto")};
    --sticky-asset-left: ${props => props.$thStyle["--sticky-asset-left"] || "54px"};
    --sticky-column-left: ${props => props.$thStyle["--sticky-column-left"] || "54px"};
    left: ${props => (props.$thStyle.left ? `${props.$thStyle.left} !important` : "auto")};
`;
class Table extends Component {
    constructor(props) {
        super(props);
        this.tableContainerRef = createRef();
        this.filterDropdownAnimationFrame = null;
    }
    state = {
        selectedFieldForCommonSearch: null,
        filterList: [],
        commonFilterParams: this.props.commonFilter || {},
        selectAll: "",
        idArray: [],
        isLoadingDrop: false,
        valuee: "",
        sourceData: [],
        exportFilters: this.props.exportFilters || {},
        filterCount: 0,
        isResizing: false,
        tableClassName: "",
        tableLoading: false
    };
    newFilterLogic =
        [
            "assets",
            "buildings",
            "sites",
            "recommendations",
            "recommendation",
            "cr-recommendations",
            "linked-recommendations",
            "linked-cr-recommendations",
            "mr-recommendations",
            "mr-assets",
            "surveyor-profiles",
            "app-info"
        ].includes(this.props.match.params.tab) ||
        this?.props?.isAssignView ||
        ["/building", "/site"].includes(this.props.match?.path?.toLowerCase()) ||
        this.props.isSmartChartView ||
        this.props?.isSurveyAsset ||
        this.props?.hasSearchApi ||
        this.props?.isSurveyRecom;

    componentDidMount = async () => {
        document.addEventListener("mousedown", this.handleClickOutside);
        const {
            match: {
                params: { tab, settingType }
            },
            isNewTableFilters = false
        } = this.props;

        if (this.props.updateColumnWidthInConfig) this.initiateColumnResize();
        if (this.props.commonFilter) {
            if (Object.keys(this.props.commonFilter).length !== 0) {
                let test = {};
                Object.keys(this.props.commonFilter).map(fil => {
                    if (
                        tab === "recommendations" ||
                        tab === "cr-recommendations" ||
                        tab === "linked-recommendations" ||
                        tab === "linked-cr-recommendations" ||
                        tab === "assets" ||
                        tab === "dashboard" ||
                        tab === "recommendation" ||
                        settingType === "client_standards" ||
                        this.props.match.path === "/initiatives" ||
                        this.props.match.path === "/dashboard" ||
                        this.props.match.path === "/documents" ||
                        isNewTableFilters ||
                        this.props.isSmartChartView ||
                        this?.props?.isAssignView ||
                        settingType === "client_standards_hierarchy" ||
                        settingType === "entity" ||
                        this.props?.isSurveyRecom
                    ) {
                        test = { ...test, [fil]: true };
                    } else {
                        let keyName = [fil] + "." + Object.keys(this.props.commonFilter[fil])[0];
                        test = { ...test, [keyName]: true };
                    }
                });
            }
        }
        window.addEventListener("resize", this.checkTableHeight);
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.searchField !== this.props.searchField) {
            this.scrollToColumn(this.props.searchField);
        }
        if (prevProps.sortFilters !== this.props.sortFilters) {
            this.setState({
                sortFilters: this.props.sortFilters || {}
            });
        }
        if (
            prevProps.commonFilter !== this.props.commonFilter ||
            this.state.selectedFieldForCommonSearch !== prevState.selectedFieldForCommonSearch
        ) {
            if (this.props.commonFilter) {
                const { selectAll } = [];
                let temp = selectAll;
                Object.keys(this.props.commonFilter).forEach(fil => {
                    if (this.props.commonFilter?.[fil]?.name?.length === this.state.filterList?.length) {
                        temp = { ...selectAll, [fil]: true };
                    }
                });
                this.setState({
                    selectAll: temp,
                    commonFilterParams: this.props.commonFilter || {},
                    exportFilters: this.props.exportFilters || {}
                });
            } else {
                this.setState({
                    selectAll: {},
                    commonFilterParams: this.props.commonFilter || {},
                    exportFilters: this.props.exportFilters || {}
                });
            }
        }
        if (prevProps.recomentationIds != this.props.recomentationIds) {
            if (!this.props.recomentationIds.length) {
                this.setState({
                    idArray: []
                });
                localStorage.removeItem("recommendationIds");
                localStorage.removeItem("selectAll");
            } else if (this.props.isAssignProject) {
                this.setState({
                    idArray: this.props.recomentationIds
                });
            }
        }
        if (prevProps.selectedAllClicked !== this.props.selectedAllClicked) {
            let selectAllClicked = localStorage.getItem("selectAllClicked");
            if (!this.props.selectedAllClicked || !selectAllClicked) {
                this.setState({
                    idArray: []
                });
                localStorage.removeItem("recommendationIds");
                localStorage.removeItem("selectAll");
            }
        }
        // Both branches below are expensive on wide tables -- rebinding every tooltip in the
        // document, and a getBoundingClientRect + setState that costs a second render pass. Gate
        // them on the parts that actually changed, so a parent that rebuilds only the tableData
        // wrapper does not trigger them.
        const tableDataStructurallyChanged =
            prevProps.tableData?.keys !== this.props.tableData?.keys ||
            prevProps.tableData?.config !== this.props.tableData?.config ||
            prevProps.tableData?.data !== this.props.tableData?.data;
        if (tableDataStructurallyChanged) {
            ReactTooltip.rebuild();
        }
        if (
            (prevProps.tableData?.config !== this.props.tableData?.config || prevProps.tableData?.keys !== this.props.tableData?.keys) &&
            this.props.updateColumnWidthInConfig
        ) {
            this.initiateColumnResize();
        }
        if (this.props?.isNewTableFilters && this.props?.commonFilterData !== prevProps?.commonFilterData) {
            this.setState(
                {
                    filterList: this.props?.commonFilterData?.list?.length ? [...this.props.commonFilterData?.list] : [],
                    filterCount:
                        this.props?.isRecommendationLog || (this.props?.hasSearchApi && !this.state?.valuee)
                            ? this.props?.commonFilterData?.count
                            : this.state?.filterCount,
                    isLoadingDrop: false
                },
                () => {
                  
                    if (this.state.selectedFieldForCommonSearch) {
                        this.scrollFilterDropdownIntoView();
                    }
                }
            );
        }
        if (tableDataStructurallyChanged) {
            this.checkTableHeight();
        }
    };

    componentWillUnmount = () => {
        document.removeEventListener("mousedown", this.handleClickOutside);
        window.removeEventListener("resize", this.checkTableHeight);
        if (this.filterDropdownAnimationFrame) {
            cancelAnimationFrame(this.filterDropdownAnimationFrame);
        }
    };
    setWrapperRef = node => {
        this.wrapperRef = node;
    };

    handleClickOutside = event => {
        // Bound to document, so this runs for every mousedown in the app. Skip the
        // setState when nothing is open, otherwise each click re-renders the table.
        if (!this.state.selectedFieldForCommonSearch) return;
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({
                selectedFieldForCommonSearch: ""
            });
        }
    };

    handleSelectRow = (e, id) => {
        if (
            (this.props.match.params.tab === "recommendations" ||
                this.props.match.params.tab === "cr-recommendations" ||
                this.props.match.params.tab === "recommendation" ||
                this.props?.isSurveyRecom) &&
            !this.props.isAssignProject
        ) {
            let tempIds = localStorage.getItem("recommendationIds") ? JSON.parse(localStorage.getItem("recommendationIds")) : [];
            if (e.target.checked) {
                tempIds.push(id);
                this.setState({
                    idArray: tempIds
                });
                localStorage.setItem("recommendationIds", JSON.stringify(tempIds));
            } else {
                tempIds = tempIds.filter(t => t != id);
                this.setState({
                    idArray: tempIds
                });
                localStorage.setItem("recommendationIds", JSON.stringify(tempIds));
                localStorage.removeItem("selectAll");
                this.props.resetSelect();
            }
        } else {
            this.props.handleSelect(e, id);
        }
    };

    handleSelectAllRow = (e, dataItem) => {
        if (
            (this.props.match.params.tab === "recommendations" ||
                this.props.match.params.tab === "cr-recommendations" ||
                this.props.match.params.tab === "recommendation") &&
            !this.props.isAssignProject
        ) {
            let temp = [];
            if (e.target.checked) {
                if (dataItem && dataItem.data) {
                    dataItem.data.map(d => temp.push(d.id));
                }
                localStorage.setItem("selectAll", true);
            } else {
                temp = [];
                localStorage.removeItem("selectAll");
                localStorage.setItem("selectAllClicked", false);
            }
            this.setState({
                idArray: temp
            });
            localStorage.setItem("recommendationIds", JSON.stringify(temp));
            this.props.handleSelectAll(e, dataItem);
        } else {
            this.props.handleSelectAll(e, dataItem);
        }
    };

    setSortOrderParams = async (event, searchKey, val, tableData, fieldConfig) => {
        if (tableData && tableData.data && tableData.data.length) {
            var thIconsContainer = document.getElementById(`thIconsContainer_${searchKey}`);
            if (thIconsContainer && !thIconsContainer.contains(event.target)) {
                this.setState({ tableLoading: true });
                await new Promise(resolve => setTimeout(resolve, 1));
                let searchKeyValue = searchKey;
                if (this.props?.isRecommendationLog) {
                    searchKeyValue = tableData?.config
                        ? Object.values(tableData?.config || {}).find(item => item.searchKey === searchKey)?.sortKey
                        : searchKey;
                }
                await this.props.updateTableSortFilters(searchKeyValue, val, fieldConfig);
                this.setState({ tableLoading: false });
            }
        }
    };
    setSortOrderParamsByArrow = async (event, searchKey, val, tableData) => {
        if (tableData && tableData.data && tableData.data.length) {
            this.setState({ tableLoading: true });
            await new Promise(resolve => setTimeout(resolve, 1));
            await this.props.updateTableSortFilters(searchKey, val);
            this.setState({ tableLoading: false });
        }
    };

    showCommonSearchDropDown = async keyItem => {
        const {
            tableData,
            match: {
                params: { tab, settingType }
            },
            isNewTableFilters = false,
            isRecommendationLog = false,
            isSurveyAsset = false,
            hasSearchApi = false,
            isSurveyRecom = false
        } = this.props;
        const searchKey =
            tab === "recommendations" ||
            tab === "recommendation" ||
            tab === "assets" ||
            tab === "cr-recommendations" ||
            tab === "linked-recommendations" ||
            tab === "linked-cr-recommendations" ||
            tab === "mr-recommendations" ||
            tab === "dashboard" ||
            this.props.isSmartChartView ||
            settingType === "recommendationTemplate" ||
            settingType === "client_standards" ||
            this.props.isAssetSurveyProject ||
            this.props.isTaskManager ||
            this.props?.isSurveyAsset ||
            tab === "app-project-info" ||
            tab === "surveyor-project-history" ||
            settingType === "client_standards_hierarchy" ||
            hasSearchApi ||
            isSurveyRecom ||
            this.props?.match?.params?.subTab === "app-project-info" ||
            tab === "fca-app-project-info"
                ? tableData.config[keyItem]?.getListTable
                : tableData.config[keyItem]?.searchKey;
        const isOpeningDropdown = this.state.selectedFieldForCommonSearch !== keyItem;
        this.setState(
            {
                isLoadingDrop: true,
                selectedFieldForCommonSearch: isOpeningDropdown ? keyItem : null,
                valuee: ""
            },
            () => {
                if (isOpeningDropdown) {
                    this.scrollFilterDropdownIntoView();
                }
            }
        );

        let getListParsms = { field: searchKey, searchKey: tableData.config[keyItem]?.searchKey };
        if (this.newFilterLogic && !isRecommendationLog && !isSurveyAsset && !hasSearchApi) {
            let { list = [], count = 0 } =
                this.state.selectedFieldForCommonSearch === keyItem ? {} : await this.props.getListForCommonFilter(getListParsms);

            this.setState(
                {
                    filterList: list,
                    filterCount: count,
                    isLoadingDrop: false
                },
                () => {
                    if (isOpeningDropdown) {
                        this.scrollFilterDropdownIntoView();
                    }
                }
            );
        } else {
            let filterList = this.state.selectedFieldForCommonSearch === keyItem ? null : await this.props.getListForCommonFilter(getListParsms);
            if (!isNewTableFilters) {
                this.setState(
                    {
                        filterList,
                        isLoadingDrop: false
                    },
                    () => {
                        if (isOpeningDropdown) {
                            this.scrollFilterDropdownIntoView();
                        }
                    }
                );
            }
        }
    };

    setCommonFilterParams = async (keyItem, data) => {
        this.setState({ tableLoading: true });
        await new Promise(resolve => setTimeout(resolve, 1));
        const {
            match: {
                params: { tab, settingType }
            },
            tableData: { config },
            isNewTableFilters = false
        } = this.props;
        const { commonSearchKey, commonSearchObjectKey, searchKey, filterIdKey, commonFilterId = null } = config[keyItem] || {};
        const { id: valueId, name: value } = data;
        const newValue = commonFilterId ? valueId : value;
        let tempList = this.state.commonFilterParams;
        let exportFilters = this.state.exportFilters ? { ...this.state.exportFilters } : {};
        let alreadyFiltered = false;
        if (
            tab === "recommendations" ||
            tab === "cr-recommendations" ||
            tab === "linked-recommendations" ||
            tab === "linked-cr-recommendations" ||
            tab === "mr-recommendations" ||
            tab === "assets" ||
            tab === "dashboard" ||
            tab === "recommendation" ||
            settingType === "client_standards" ||
            this.props.match.path === "/initiatives" ||
            this.props.match.path === "/dashboard" ||
            this.props.match.path === "/documents" ||
            isNewTableFilters ||
            this.props.isSmartChartView ||
            this?.props?.isAssignView ||
            settingType === "client_standards_hierarchy" ||
            settingType === "entity" ||
            this.props?.isSurveyRecom
        ) {
            if (tempList[searchKey]) {
                if (!tempList[searchKey].includes(newValue)) {
                    tempList = { ...tempList, [searchKey]: [...tempList[searchKey], newValue] };
                } else {
                    tempList = { ...tempList, [searchKey]: tempList[searchKey].filter(item => item !== newValue) };

                    if (!tempList[searchKey].length) {
                        tempList = { ...tempList, [searchKey]: undefined };
                    }
                }
            } else {
                tempList = { ...tempList, [searchKey]: [newValue] };
            }
            /***************** for data export filters  #start*/
            if ((filterIdKey && valueId) || (isNewTableFilters && filterIdKey)) {
                if (exportFilters[filterIdKey]?.length) {
                    alreadyFiltered = true;
                    if (!exportFilters[filterIdKey].includes(valueId)) {
                        exportFilters = { ...exportFilters, [filterIdKey]: [...exportFilters[filterIdKey], valueId] };
                    } else {
                        exportFilters[filterIdKey] = exportFilters[filterIdKey].filter(item => item !== valueId);

                        if (!exportFilters[filterIdKey].length) {
                            exportFilters = { ...exportFilters, [filterIdKey]: undefined };
                        }
                    }
                } else {
                    if (!alreadyFiltered) exportFilters[filterIdKey] = [valueId];
                }
            } else {
                if (exportFilters[searchKey]) {
                    if (!exportFilters[searchKey].includes(value)) {
                        exportFilters[searchKey].push(value);
                    } else {
                        exportFilters[searchKey] = exportFilters[searchKey].filter(item => item !== value);

                        if (!exportFilters[searchKey].length) delete exportFilters[searchKey];
                    }
                } else {
                    exportFilters[searchKey] = [value];
                }
            }
            /***************** for data export filters  #end*/
            let isSelectAll;
            if (tempList && tempList[searchKey] && tempList[searchKey].length === this.state.filterList.length) {
                isSelectAll = true;
            } else {
                isSelectAll = false;
            }

            this.setState(prevState => ({
                commonFilterParams: tempList,
                exportFilters: exportFilters,
                selectAll: { ...prevState.selectAll, [searchKey]: isSelectAll }
            }));
        } else {
            if (tempList[commonSearchKey] && tempList[commonSearchKey][commonSearchObjectKey]) {
                if (!tempList[commonSearchKey][commonSearchObjectKey].includes(value)) {
                    tempList = {
                        ...tempList,
                        [commonSearchKey]: {
                            ...tempList[commonSearchKey],
                            [commonSearchObjectKey]: [...tempList[commonSearchKey][commonSearchObjectKey], value]
                        }
                    };
                } else {
                    tempList = {
                        ...tempList,
                        [commonSearchKey]: {
                            ...tempList[commonSearchKey],
                            [commonSearchObjectKey]: tempList[commonSearchKey][commonSearchObjectKey].filter(item => item !== value)
                        }
                    };

                    if (!tempList[commonSearchKey][commonSearchObjectKey].length)
                        tempList = {
                            ...tempList,
                            [commonSearchKey]: {
                                ...tempList[commonSearchKey],
                                [commonSearchObjectKey]: undefined
                            }
                        };
                    if (!Object.values(tempList[commonSearchKey]).some(e => e)) tempList = { ...tempList, [commonSearchKey]: undefined };
                }
            } else {
                tempList = { ...tempList, [commonSearchKey]: { ...tempList[commonSearchKey], [commonSearchObjectKey]: [value] } };
            }
            // let isSelectAll;
            // if (tempList && tempList[commonSearchKey] && tempList[commonSearchKey][commonSearchObjectKey].length === this.state.filterList.length) {
            //     isSelectAll = true;
            // } else {
            //     isSelectAll = false;
            // }
            this.setState(prevState => ({
                commonFilterParams: tempList
                // selectAll: { ...prevState.selectAll, [commonSearchKey]: isSelectAll }
            }));
        }
        this.setState({ tableLoading: false });
    };

    updateCommonFilterHandler = async (searchKey, key) => {
        const { commonFilterParams, exportFilters } = this.state;
        this.setState({
            valuee: "",
            tableLoading: true
        });
        await new Promise(resolve => setTimeout(resolve, 1));
        if (Object.keys(commonFilterParams).length !== 0) {
            this.props.updateCommonFilter(commonFilterParams, exportFilters, key, searchKey);
        }
        this.setState({
            selectedFieldForCommonSearch: null,
            tableLoading: false
        });
    };

    cancelCommonFilterHandler = async keyItem => {
        const {
            match: {
                params: { tab }
            },
            tableData: { config },
            isNewTableFilters = false
        } = this.props;
        const { commonSearchKey, searchKey, filterIdKey } = config[keyItem] || {};
        let tempList = this.state.commonFilterParams;
        let { exportFilters } = this.state;
        this.setState({
            valuee: "",
            tableLoading: true
        });
        await new Promise(resolve => setTimeout(resolve, 1));
        if (
            tab === "recommendations" ||
            tab === "cr-recommendations" ||
            tab === "linked-recommendations" ||
            tab === "linked-cr-recommendations" ||
            tab === "mr-recommendations" ||
            tab === "assets" ||
            tab === "dashboard" ||
            tab === "recommendation" ||
            this.props.match.path === "/initiatives" ||
            this.props.match.path === "/dashboard" ||
            this.props.match.path === "/documents" ||
            isNewTableFilters ||
            this.props.isSmartChartView ||
            this?.props?.isAssignView ||
            this.props?.isSurveyRecom
        ) {
            if (tempList[searchKey]) {
                tempList = { ...tempList, [searchKey]: undefined };
                if (filterIdKey && exportFilters[filterIdKey]) {
                    delete exportFilters[filterIdKey];
                } else if (exportFilters[searchKey]) {
                    delete exportFilters[searchKey];
                }
            }

            this.setState(prevState => ({
                selectedFieldForCommonSearch: null,
                selectAll: { ...prevState.selectAll, [searchKey]: false },
                commonFilterParams: tempList
            }));
        } else {
            if (tempList[commonSearchKey]) {
                tempList = { ...tempList, [commonSearchKey]: undefined };
            }

            this.setState(prevState => ({
                commonFilterParams: tempList,
                selectedFieldForCommonSearch: null,
                selectAll: { ...prevState.selectAll, [commonSearchKey]: false }
            }));
        }
        this.setState({ tableLoading: false });
    };
    selectAllHandler = async (keyItem, allSelect, availableValues) => {
        this.setState({ tableLoading: true });
        await new Promise(resolve => setTimeout(resolve, 1));
        const {
            match: {
                params: { tab, settingType }
            },
            isNewTableFilters = false
        } = this.props;
        if (
            tab === "recommendations" ||
            tab === "cr-recommendations" ||
            tab === "linked-recommendations" ||
            tab === "linked-cr-recommendations" ||
            tab === "mr-recommendations" ||
            tab === "assets" ||
            tab === "dashboard" ||
            tab === "recommendation" ||
            settingType === "client_standards" ||
            this.props.match.path === "/initiatives" ||
            this.props.match.path === "/dashboard" ||
            this.props.match.path === "/documents" ||
            isNewTableFilters ||
            this.props.isSmartChartView ||
            this?.props?.isAssignView ||
            settingType === "client_standards_hierarchy" ||
            settingType === "entity" ||
            this.props?.isSurveyRecom
        ) {
            const selctAll = !allSelect;
            let { exportFilters } = this.state;
            const { commonFilterId = null } = keyItem || {};
            let filterListName = availableValues.map(item => (commonFilterId ? item?.id : item.name));
            let filterListId = availableValues.map(item => item.id);
            let tempList = this.state.commonFilterParams;
            if (selctAll) {
                const prevData = tempList?.[keyItem?.searchKey] || [];
                tempList = { ...tempList, [keyItem.searchKey]: [...prevData, ...filterListName] };
            } else {
                tempList = { ...tempList, [keyItem.searchKey]: undefined };
            }

            /***************** for data export filters  #start*/
            if (keyItem.filterIdKey) {
                const prevData = exportFilters?.[keyItem?.filterIdKey] || [];
                if (selctAll) {
                    exportFilters[keyItem.filterIdKey] = [...prevData, ...filterListId];
                } else if (exportFilters.hasOwnProperty(keyItem.filterIdKey)) {
                    delete exportFilters[keyItem.filterIdKey];
                }
            } else {
                const prevData = exportFilters?.[keyItem?.searchKey] || [];
                if (selctAll) {
                    exportFilters[keyItem.searchKey] = [...prevData, ...filterListName];
                } else if (exportFilters.hasOwnProperty(keyItem.searchKey)) {
                    delete exportFilters[keyItem.searchKey];
                }
            }
            /***************** for data export filters  #end*/

            this.setState(prevState => ({
                selectAll: { ...prevState.selectAll, [keyItem.searchKey]: selctAll },
                commonFilterParams: tempList,
                exportFilters
            }));
        } else {
            const selctAll = !allSelect;
            let filterListName = availableValues.map(item => item.name);
            let tempList = this.state.commonFilterParams;

            if (selctAll) {
                const prevData = tempList[keyItem?.commonSearchKey]?.[keyItem?.commonSearchObjectKey] || [];
                tempList = {
                    ...tempList,
                    [keyItem.commonSearchKey]: {
                        ...tempList[keyItem.commonSearchKey],
                        [keyItem.commonSearchObjectKey]: [...prevData, ...filterListName]
                    }
                };
                this.setState(prevState => ({
                    selectAll: { ...prevState.selectAll, [keyItem.commonSearchKey]: selctAll },
                    commonFilterParams: tempList
                }));
            } else {
                tempList = {
                    ...tempList,
                    [keyItem.commonSearchKey]: { ...tempList[keyItem.commonSearchKey], [keyItem.commonSearchObjectKey]: undefined }
                };
                if (!Object.values(tempList[keyItem.commonSearchKey]).some(e => e)) tempList = { ...tempList, [keyItem.commonSearchKey]: undefined };
                this.setState(prevState => ({
                    selectAll: { ...prevState.selectAll, [keyItem.commonSearchKey]: selctAll },
                    commonFilterParams: tempList
                }));
            }
        }
        this.setState({ tableLoading: false });
    };

    clearDropdown = async (commonSearchKey, commonSearchObjectKey, keyItem, searchKey, filterIdKey) => {
        this.setState({ tableLoading: true });
        await new Promise(resolve => setTimeout(resolve, 1));
        const {
            match: {
                params: { tab, settingType }
            },
            isNewTableFilters = false
        } = this.props;
        let tempList = this.state.commonFilterParams;
        let tempExportFilterList = this.state.exportFilters;
        if (
            tab === "recommendations" ||
            tab === "cr-recommendations" ||
            tab === "linked-recommendations" ||
            tab === "linked-cr-recommendations" ||
            tab === "mr-recommendations" ||
            tab === "assets" ||
            tab === "dashboard" ||
            settingType === "client_standards" ||
            tab === "recommendation" ||
            this.props.match.path === "/initiatives" ||
            this.props.match.path === "/dashboard" ||
            this.props.match.path === "/documents" ||
            isNewTableFilters ||
            this.props.isSmartChartView ||
            this?.props?.isAssignView ||
            settingType === "client_standards_hierarchy" ||
            settingType === "entity" ||
            this.props?.isSurveyRecom
        ) {
            if (tempList[searchKey]) {
                tempList = { ...tempList, [searchKey]: undefined };
                delete tempExportFilterList[searchKey];
            }

            if (tempExportFilterList[filterIdKey]?.length) {
                tempExportFilterList = { ...tempExportFilterList, [filterIdKey]: undefined };
            }

            this.setState(prevState => ({
                commonFilterParams: tempList,
                selectAll: { ...prevState.selectAll, [keyItem.searchKey]: false },
                exportFilters: tempExportFilterList
            }));
        } else {
            if (tempList[commonSearchKey]) {
                tempList = { ...tempList, [commonSearchKey]: { ...tempList[commonSearchKey], [keyItem.commonSearchObjectKey]: undefined } };
                if (!Object.values(tempList[commonSearchKey]).some(e => e)) tempList = { ...tempList, [commonSearchKey]: undefined };
            }

            this.setState(prevState => ({
                commonFilterParams: tempList,
                selectAll: { ...prevState.selectAll, [keyItem.commonSearchKey]: false }
            }));
        }
        this.setState({ tableLoading: false });
    };

    handleFilterSearch = async (value, filterKey) => {
        const { filterCount, filterList } = this.state;
        this.setState({
            valuee: value
        });
        const { isRecommendationLog = false, isSurveyAsset = false, hasSearchApi = false } = this.props;
        if (
            this.newFilterLogic &&
            filterCount > 0 &&
            filterCount !== filterList?.length &&
            (!isRecommendationLog || (isRecommendationLog && filterKey === "recommendation_code"))
        ) {
            this.debounceSearch(filterKey);
        }
    };

    debounceSearch = debounce(async keyItem => {
        this.setState({
            isLoadingDrop: true
        });
        const { isRecommendationLog = false, isSurveyAsset = false, hasSearchApi = false } = this.props;

        const {
            tableData,
            match: {
                params: { tab, settingType }
            }
        } = this.props;
        const { valuee } = this.state;
        const searchKey =
            tab === "recommendations" ||
            tab === "recommendation" ||
            tab === "assets" ||
            tab === "cr-recommendations" ||
            tab === "linked-recommendations" ||
            tab === "linked-cr-recommendations" ||
            tab === "mr-recommendations" ||
            tab === "dashboard" ||
            settingType === "client_standards" ||
            this.props.isSmartChartView ||
            this.props.isAssetSurveyProject ||
            this.props.isGeneralTaskManager ||
            tab === "app-project-info" ||
            tab === "surveyor-project-history" ||
            settingType === "client_standards_hierarchy" ||
            hasSearchApi ||
            this.props?.isSurveyRecom ||
            this.props?.match?.params?.subTab === "app-project-info" ||
            tab === "fca-app-project-info"
                ? tableData.config[keyItem]?.getListTable
                : tableData.config[keyItem]?.searchKey;

        let getListParsms = {
            field: searchKey,
            searchKey:
                isRecommendationLog && keyItem === "recommendation_code"
                    ? tableData.config[keyItem]?.commonSearchKey
                    : tableData.config[keyItem]?.searchKey
        };
        if (valuee && valuee.trim()?.length) {
            getListParsms.search_filters = { [getListParsms.searchKey]: { key: valuee } };
        }
        const listResponse = (await this.props.getListForCommonFilter(getListParsms)) || {};
        let { list = [], count = 0 } = listResponse;
        this.setState(
            {
                // filterCount: count,
                filterList: list,
                // Callers that return no list take their options from commonFilterData later, so they keep waiting.
            isLoadingDrop: (isRecommendationLog || isSurveyAsset || hasSearchApi) && !Array.isArray(listResponse.list)
            },
            this.scrollFilterDropdownIntoView
        );
    }, 1000);

    renderFiltersForCommonSearch = keyItem => {
        const {
            match: {
                params: { tab, settingType }
            },
            isNewTableFilters = false
        } = this.props;
        if (this.state.selectedFieldForCommonSearch !== keyItem) {
            return null;
        }
        const {
            tableData: { config },
            isRecommendationLog = false,
            viewOnly = false
        } = this.props;

        let { filterList = [], valuee, commonFilterParams, isLoadingDrop, filterCount } = this.state;
        filterList = Array.isArray(filterList) ? filterList?.filter(item => item.name !== null && item.name !== "") : [];
        let searchedList = filterList;
        if (this.props?.isSurveyAsset && keyItem === "asset_survey_status") {
            filterList = filterList?.map(item => {
                if (item.id !== "7") {
                    item.group = "Active";
                } else item.group = null;
                return item;
            });
        }
        if (this.props?.isSurveyRecom && keyItem === "status") {
            filterList = filterList?.map(item => {
                if (item.id !== "5") {
                    item.group = "Active";
                } else item.group = null;
                return item;
            });
        }
        if (valuee && (filterCount <= 100 || (isRecommendationLog && keyItem !== "recommendation_code"))) {
            const searchValue = valuee.toLowerCase();
            searchedList = filterList.filter(item => {
                let nameText;
                if (keyItem === "capital_type") {
                    nameText = this.getCapitalTypeData(item.name);
                } else {
                    const raw = String(item.name);
                    const baseText = raw === "true" ? "yes" : raw === "false" ? "no" : raw;
                    if (keyItem === "source" && config[keyItem]?.miscellaneous) {
                        nameText = formatCapitalRequestSourceValue(baseText, config[keyItem].miscellaneous);
                    } else if (config[keyItem]?.formatFilterLabel) {
                        nameText = config[keyItem].formatFilterLabel(item.name);
                    } else {
                        nameText = baseText;
                    }
                }

                const { appendColumnKey } = config[keyItem] || {};
                if (appendColumnKey && item[appendColumnKey] != null) {
                    nameText += ` (${item[appendColumnKey]})`;
                }

                const descriptionText = item.description != null ? String(item.description) : "";

                const composite = `${nameText} ${descriptionText}`.toLowerCase();

                return composite.includes(searchValue);
            });
        }

        let filterListToCheck =
            tab === "recommendations" ||
            tab === "cr-recommendations" ||
            tab === "linked-recommendations" ||
            tab === "linked-cr-recommendations" ||
            tab === "mr-recommendations" ||
            tab === "assets" ||
            tab === "dashboard" ||
            tab === "recommendation" ||
            settingType === "client_standards" ||
            this.props.match.path === "/initiatives" ||
            this.props.match.path === "/documents" ||
            this.props.match.path === "/dashboard" ||
            isNewTableFilters ||
            this?.props?.isAssignView ||
            this.props.isSmartChartView ||
            settingType === "client_standards_hierarchy" ||
            settingType === "entity" ||
            this.props?.isSurveyRecom
                ? commonFilterParams?.[config?.[keyItem]?.searchKey]?.length
                    ? commonFilterParams[config[keyItem].searchKey]
                    : []
                : commonFilterParams?.[config?.[keyItem]?.commonSearchKey]?.[config?.[keyItem]?.commonSearchObjectKey]?.length
                ? commonFilterParams?.[config?.[keyItem]?.commonSearchKey]?.[config?.[keyItem]?.commonSearchObjectKey]
                : [];
        const { commonFilterId = null } = config[keyItem] || {};
        let selectedValues = filterList?.filter(item => filterListToCheck?.includes(commonFilterId ? item?.id : item.name)) || [];
        let availableValues = searchedList?.filter(item => !filterListToCheck?.includes(commonFilterId ? item?.id : item.name)) || [];
        const isAllSelected = selectedValues?.length > 0 && isEqual(searchedList, selectedValues);
        const hasDashboardColumnFilter = this.hasAssetDashboardColumnFilter(config[keyItem]?.searchKey);
        return (
            <div className="dropdown-menu drop-filtr pos-abs dp-rcm-overflow table-filter-dropdown">
                {hasDashboardColumnFilter && (
                    <div className="col-md-12 p-2 border-bottom dashboard-filter-indicator">
                        <span className="badge badge-primary">Dashboard Filter</span>
                    </div>
                )}
                <div className="col-md-12 p-0 slt">
                    <span className="dropdown-item build_search_drp">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={this.state.valuee}
                            onChange={e => this.handleFilterSearch(e.target.value, keyItem)}
                            disabled={viewOnly}
                            className={viewOnly ? "cursor-disabled" : ""}
                        />
                        <i
                            class={`fas fa-times cursor-pointer cls-close ${viewOnly ? "cursor-disabled" : ""}`}
                            onClick={() => this.handleFilterSearch("", keyItem)}
                        />
                        <label className={`container-check ${viewOnly ? "cursor-disabled" : ""}`}>
                            {`Select All (${selectedValues?.length}/${selectedValues?.length + availableValues?.length}) ${
                                filterCount > 100 ? `Total: ${filterCount}` : ""
                            }`}
                            <input
                                type="checkbox"
                                checked={isAllSelected}
                                onChange={() => this.selectAllHandler(config[keyItem], isAllSelected, availableValues)}
                                disabled={viewOnly}
                            />
                            <span className="checkmark"></span>
                            <button
                                className={`clear-btn-selection ${viewOnly ? "cursor-disabled" : ""}`}
                                onClick={e => {
                                    e.preventDefault();
                                    this.clearDropdown(
                                        config[keyItem].commonSearchKey,
                                        config[keyItem].commonSearchObjectKey,
                                        config[keyItem],
                                        config[keyItem].searchKey,
                                        config[keyItem].filterIdKey
                                    );
                                }}
                                disabled={viewOnly}
                            >
                                Clear
                            </button>
                        </label>
                    </span>
                </div>
                <>
                    {!isLoadingDrop ? (
                        <>
                            {config?.[keyItem]?.hasGroupBy ? (
                                <GroupByFilter
                                    options={searchedList}
                                    keyItem={keyItem}
                                    setCommonFilterParams={this.setCommonFilterParams}
                                    getCapitalTypeData={this.getCapitalTypeData}
                                    selectedValues={selectedValues}
                                    isSurveyAsset={this.props?.isSurveyAsset}
                                />
                            ) : (
                                <>
                                    {selectedValues?.length > 0 && (
                                        <div className="col-md-12 p-0 slt-ara border-bottom sub-drop-ara">
                                            {selectedValues?.map((item, i) => (
                                                <span key={i} className="dropdown-item notranslate">
                                                    <ReactTooltip id="building-dropdown" />
                                                    {item.name !== null && item.name !== "" ? (
                                                        <FilterItem
                                                            item={item}
                                                            keyItem={keyItem}
                                                            getCapitalTypeData={this.getCapitalTypeData}
                                                            setCommonFilterParams={this.setCommonFilterParams}
                                                            checked={true}
                                                            viewOnly={viewOnly}
                                                            isSurveyAsset={this.props?.isSurveyAsset}
                                                            fieldConfig={config?.[keyItem]}
                                                        />
                                                    ) : null}
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                    <div className={`col-md-12 p-0 slt-ara ${selectedValues?.length >= 2 ? "sld-check-maindrop" : ""}`}>
                                        {availableValues?.length > 0 &&
                                            availableValues?.map((item, i) => (
                                                <span key={i} className="dropdown-item notranslate">
                                                    <ReactTooltip id="building-dropdown" />
                                                    {item.name !== null && item.name !== "" ? (
                                                        <FilterItem
                                                            item={item}
                                                            keyItem={keyItem}
                                                            getCapitalTypeData={this.getCapitalTypeData}
                                                            setCommonFilterParams={this.setCommonFilterParams}
                                                            checked={false}
                                                            viewOnly={viewOnly}
                                                            isSurveyAsset={this.props?.isSurveyAsset}
                                                            fieldConfig={config?.[keyItem]}
                                                        />
                                                    ) : null}
                                                </span>
                                            ))}

                                        {!availableValues?.length && !selectedValues?.length ? (
                                            <div className="col-md-6 no-wrap">NO DATA</div>
                                        ) : (
                                            availableValues?.length === 0 && <div className="col-md-6 no-wrap">NO MORE VALUES TO DISPLAY</div>
                                        )}
                                        {this.newFilterLogic && availableValues?.length > 100 && (
                                            <div className="col-md-6 no-wrap">Search to display more values</div>
                                        )}
                                    </div>
                                </>
                            )}
                        </>
                    ) : (
                        <div className="col-md-12 p-3">
                            <Loader />
                        </div>
                    )}
                </>

                {filterList?.length || selectedValues?.length ? (
                    <div className="col-md-12 mt-3 drp-btn">
                        <button
                            type="button"
                            className={`btn btn-primary mr-2 ${viewOnly ? "cursor-disabled" : ""}`}
                            onClick={() => this.updateCommonFilterHandler(config[keyItem].searchKey, keyItem)}
                            disabled={viewOnly}
                        >
                            OK
                        </button>
                        <button
                            type="button"
                            className={`btn btn-primary btnClr ${viewOnly ? "cursor-disabled" : ""}`}
                            onClick={() => this.cancelCommonFilterHandler(keyItem)}
                            disabled={viewOnly}
                        >
                            Cancel
                        </button>
                    </div>
                ) : null}
            </div>
        );
    };

    checkHasCommonFilters = (commonSearchKey, commonSearchObjectKey, searchKey) => {
        const {
            match: {
                params: { tab, settingType }
            },
            isNewTableFilters = false
        } = this.props;
        const { tableParams = null } = this.props;
        if (tableParams) {
            if (
                tab === "recommendations" ||
                tab === "cr-recommendations" ||
                tab === "linked-recommendations" ||
                tab === "linked-cr-recommendations" ||
                tab === "mr-recommendations" ||
                tab === "assets" ||
                tab === "dashboard" ||
                tab === "recommendation" ||
                settingType === "client_standards" ||
                this.props.match.path === "/initiatives" ||
                this.props.match.path === "/dashboard" ||
                this.props.match.path === "/documents" ||
                isNewTableFilters ||
                this.props.isSmartChartView ||
                this?.props?.isAssignView ||
                settingType === "client_standards_hierarchy" ||
                settingType === "entity" ||
                this.props?.isSurveyRecom
            ) {
                if (tableParams.list && tableParams.list[searchKey] && tableParams.list[searchKey].length) {
                    return true;
                }
            } else {
                if (
                    tableParams.list &&
                    tableParams.list[commonSearchKey] &&
                    tableParams.list[commonSearchKey][commonSearchObjectKey] &&
                    tableParams.list[commonSearchKey][commonSearchObjectKey].length
                ) {
                    return true;
                }
            }
        }
        return false;
    };

    hasAssetDashboardColumnFilter = searchKey => hasAssetDashboardColumnFilter(this.props.assetDashboardFilterParams, searchKey);

    getCapitalTypeData = key => {
        switch (key) {
            case "NI":
                return "Non-Infrastructure";
            case "DM":
                return "Deferred Maintenance";
            case "FC":
                return "Future Capital";
            default:
                return key;
        }
    };

    initiateColumnResize = () => {
        const tableHeaders = document.querySelectorAll("[class*='resize-col-']");
        const minWidth = 130;
        const maxWidth = 1000;

        tableHeaders.forEach((tableColumn, index) => {
            let columnKey = tableColumn.getAttribute("data-key-item");

            if (tableColumn.querySelector(`.resizer-${columnKey}`)) {
                return;
            }

            let resizer = document.createElement("div");
            tableColumn.classList.add("resizable");
            resizer.className = `resizer-${columnKey} resize-drag`;
            resizer.id = `resizer-${index}`;
            resizer.style.cursor = "ew-resize";
            resizer.style.width = "15px";
            resizer.style.height = "25px";
            resizer.style.position = "absolute";
            resizer.style.top = "18px";
            resizer.style.right = "4px";
            resizer.style.bottom = "0";
            resizer.style.zIndex = "1";
            resizer.style.borderRadius = "5px";
            resizer.style.textAlign = "center";
            resizer.style.display = "flex";
            resizer.style.alignItems = "center";
            resizer.style.justifyContent = "center";
            resizer.style.marginRight = "8px";

            let icon = document.createElement("img");
            icon.src = MoveIcon;
            icon.alt = "Move Icon";

            resizer.appendChild(icon);
            tableColumn.appendChild(resizer);

            let startX, startWidth;

            const initDrag = e => {
                e.preventDefault();
                startX = e.clientX;
                startWidth = parseInt(document.defaultView.getComputedStyle(tableColumn).width, 10);

                document.documentElement.addEventListener("mousemove", doDrag, false);
                document.documentElement.addEventListener("mouseup", stopDrag, false);
            };

            const doDrag = e => {
                this.setState({ isResizing: true });
                let currentWidth = startWidth + e.clientX - startX;
                if (currentWidth < minWidth) {
                    currentWidth = minWidth;
                } else if (currentWidth > maxWidth) {
                    currentWidth = maxWidth;
                }
                tableColumn.style.setProperty("width", `${currentWidth}px`, "important");
                tableColumn.style.setProperty("min-width", `${currentWidth}px`, "important");
                tableColumn.style.setProperty("max-width", `${currentWidth}px`, "important");
            };

            const stopDrag = e => {
                document.documentElement.removeEventListener("mousemove", doDrag, false);
                document.documentElement.removeEventListener("mouseup", stopDrag, false);

                const finalWidth = parseInt(tableColumn.style.width, 10);

                const style = {
                    width: `${finalWidth}px`,
                    minWidth: `${finalWidth}px`,
                    maxWidth: `${finalWidth}px`
                };
                const { updateColumnWidthInConfig } = this.props;
                if (updateColumnWidthInConfig) {
                    updateColumnWidthInConfig(columnKey, style);
                    tableColumn.style.removeProperty("width");
                    tableColumn.style.removeProperty("min-width");
                    tableColumn.style.removeProperty("max-width");
                }
                setTimeout(() => {
                    this.setState({ isResizing: false });
                }, 1000);
            };

            resizer.addEventListener("mousedown", initDrag, false);
        });
    };

    checkTableHeight = () => {
        if (this.tableContainerRef?.current) {
            const tableHeight = this.tableContainerRef?.current?.getBoundingClientRect().height;
            this.setState({ tableClassName: tableHeight > 440 ? "overf-seven " : "overf-five" });
        }
    };

    adjustFilterDropdownScroll = () => {
        const container = this.tableContainerRef?.current;
        const dropdown = container?.querySelector(".table-filter-dropdown");
        if (!container || !dropdown) return;

        dropdown.style.marginLeft = "";
        let dropdownRect = dropdown?.getBoundingClientRect();
        if (!dropdownRect?.width) return;

        const containerRect = container?.getBoundingClientRect();
        const actionHeader = container?.querySelector("thead th.action");
        const actionRect = actionHeader?.getBoundingClientRect();
        const hasStickyActionColumn =
            actionRect &&
            !container?.classList?.contains("table-no-fixed") &&
            actionRect?.left > containerRect?.left &&
            actionRect?.left < containerRect?.right;

        const buffer = 8;
        const stickyLeftHeaders = container?.querySelectorAll(
            "thead th.checkbox-container, thead th.img-sq-box, thead th.pinned"
        );
        let stickyLeftBoundary = containerRect?.left;

        stickyLeftHeaders?.forEach(header => {
            const headerRect = header?.getBoundingClientRect();
            const isVisible = headerRect?.right > containerRect?.left && headerRect?.left < containerRect?.right;
            const isAlongLeftEdge = headerRect?.left <= stickyLeftBoundary + buffer;

            if (headerRect?.width && isVisible && isAlongLeftEdge) {
                stickyLeftBoundary = Math.max(stickyLeftBoundary, headerRect?.right);
            }
        });

        const safeLeft = stickyLeftBoundary + buffer;
        const safeRight = (hasStickyActionColumn ? actionRect?.left : containerRect?.right) - buffer;
        const stickyColumnHeader = dropdown?.closest("th.sticky-column-th");

        if (stickyColumnHeader && dropdownRect?.left < safeLeft) {
            dropdown.style.marginLeft = `${safeLeft - dropdownRect?.left}px`;
            dropdownRect = dropdown?.getBoundingClientRect();
        }
        let scrollDelta = 0;

        if (dropdownRect?.right > safeRight) {
            scrollDelta = dropdownRect?.right - safeRight;
        } else if (dropdownRect?.left < safeLeft) {
            scrollDelta = dropdownRect?.left - safeLeft;
        }

        if (!scrollDelta) return;

        const maxScrollLeft = Math.max(container?.scrollWidth - container?.clientWidth, 0);
        const nextScrollLeft = Math.min(Math.max(container?.scrollLeft + scrollDelta, 0), maxScrollLeft);

        if (nextScrollLeft !== container?.scrollLeft) {
            container?.scrollTo({ left: nextScrollLeft, behavior: "auto" });
        }
    };

    scrollFilterDropdownIntoView = () => {
        this.adjustFilterDropdownScroll();

        if (this.filterDropdownAnimationFrame) {
            cancelAnimationFrame(this.filterDropdownAnimationFrame);
        }
        this.filterDropdownAnimationFrame = requestAnimationFrame(() => {
            this.filterDropdownAnimationFrame = null;
            this.adjustFilterDropdownScroll();
        });
    };

    scrollToColumn = keyItem => {
        const el = this.props?.pinnedColumnsRef?.[keyItem];
        const container = this.props?.tableRef?.current;
        if (!el || !container) return;

        let pinnedWidth = 0;
        let hasPinned = false;

        Object.values(this?.props?.pinnedColumnsRef || {})?.forEach(col => {
            if (!col) return;
            const isPinned =
                col.classList?.contains("pinned") || col.classList?.contains("sticky-asset-th") || col.classList?.contains("sticky-column-th");
            if (isPinned) {
                if (col.classList?.contains("pinned")) hasPinned = true;
                pinnedWidth += col.offsetWidth || 0;
            }
        });

        const naturalLeft = el?.offsetLeft;
        const currentScroll = container?.scrollLeft;
        const containerWidth = container?.clientWidth || 0;
        const itemWidth = el?.offsetWidth || 0;

        const isStickyNow =
            naturalLeft < currentScroll + pinnedWidth &&
            (el.classList?.contains("pinned") || el.classList?.contains("sticky-asset-th") || el.classList?.contains("sticky-column-th"));

        if (isStickyNow) {
            container.scrollTo({ left: 0, behavior: "smooth" });
            this.props?.setSearchField?.(null);
            return;
        }
        let targetScrollLeft;
        if (hasPinned) {
            targetScrollLeft = naturalLeft - pinnedWidth - 40;
        } else {
            targetScrollLeft = naturalLeft - containerWidth / 2 + itemWidth / 2;
        }

        container.scrollTo({
            left: Math.max(targetScrollLeft, 0),
            behavior: "smooth"
        });

        if (this.props?.setSearchField) this.props?.setSearchField(null);
    };

    render() {
        const {
            tableData: originalTableData,
            updateCurrentViewAllUsers,
            currentViewAllUsers,
            handleDeleteItem,
            hasEndTask,
            hasLog,
            showWildCardFilter,
            showEditPage,
            showInfoPage,
            hasInfoPage = true,
            selectedRowId,
            updateSelectedRow,
            updateWildCardFilter,
            wildCardFilter,
            handleHideColumn,
            hasColumnClose = false,
            hasSort = true,
            hasActionColumn = true,
            tableParams = null,
            isBuildingLocked,
            summaryRowData,
            summaryRowDataEnergy,
            showRestoreModal,
            isImportHistory = false,
            handleDownloadItem,
            hasPadding = false,
            permissions,
            handleSelect,
            isAssignProject,
            hasEdit,
            hasDelete,
            hasAssignToTrade = false,
            hasAssignToSystem = false,
            hasAssignToSubSystem = false,
            handleAssignToTrade,
            handleAssignToSystem,
            handleAssignToSubSystem,
            hasExport,
            isReportTemplate = false,
            handleToggleSlider,
            hasWildCardOptions = true,
            selectedRecomIds,
            handleSelectRecom,
            handleSelectAllRecom,
            handleSpecialReportActions,
            isBudgetPriority,
            isFullscreen,
            isTaskManager,
            tableRef,
            hasAssignToSpecialReport = null,
            hasAssignToReportParagraph = null,
            hasAssignToChildParagraph = null,
            hasMultiAction = false,
            handleMultiSelect,
            everyItemCheckedPerPage,
            priorityElementsData = [],
            hasTableImport,
            handleDownloadItemImport,
            showEditExportPage,
            tableActionClass = "",
            hasTabActive,
            isInputMode,
            handleCellFocus,
            handleCellValueChange,
            handleColumnPin,
            updateColumnWidthInConfig,
            pinnedColumnsRef,
            hasPin,
            lineEditingEnabled,
            isNewTableFilters = false,
            isCRSelection,
            additionalTableClass = "",
            isNewWildCardFilter = false,
            isAssignView = false,
            isRecommendationLog = false,
            hasPaneView = false,
            OnPaneViewClick,
            paneViewEnabled = false,
            commonTableClassName = "",
            viewOnly = false,
            isRecommendationTable = false,
            hasSurveyAssign,
            handleSurveyAssign,
            assignedRows,
            initialSelectedAssets = [],
            isAssetSurvey = false,
            selectedMultiRow = [],
            hasSelectAll = false,
            disableRowClickBreadcrumb = false,
            highlightSearchField = null,
            isRecomSurvey = false,
            isSurveybasedRecoms = false,
            hasErrorLog,
            hasViewLog,
            hasDownloadLog,
            findAndReplaceParams = null,
        } = this.props;

        // sorting the table keys if any of the column is pinned
        const { keys, config } = originalTableData || {};
        const pinnedKeys = keys.filter(key => config && config[key] && config[key].pinned);
        const unpinnedKeys = keys.filter(key => config && !(config[key] && config[key].pinned));

        const sortedKeys = [...pinnedKeys, ...unpinnedKeys];
        let tableData = { ...originalTableData, keys: sortedKeys };
        let columnCount = 2;
        return (
            <LoadingOverlay active={this.state.tableLoading || (lineEditingEnabled && this.props.parentLoading)} spinner={<Loader />} fadeSpeed={10}>
                <div
                    ref={node => {
                        if (tableRef) tableRef.current = node;
                        if (this.tableContainerRef) this.tableContainerRef.current = node;
                    }}
                    className={`table-section table-scroll ${isRecommendationLog ? "logs-overflow" : "table-gen-overflow"} ${
                        isBudgetPriority && !isFullscreen ? "overflow-table-hght" : isBudgetPriority && isFullscreen ? "recom-max-view" : ""
                    } ${isTaskManager || isRecommendationLog ? " " : "overflow-hght"} ${hasPadding ? "table-top-padd" : ""} ${
                        !tableData?.data?.length ? "no-data-table" : ""
                    } ${hasActionColumn && !isBuildingLocked ? "" : "table-no-fixed"} ${additionalTableClass} ${
                        this.state?.tableClassName
                    } ${commonTableClassName}`}
                >
                    <ReactTooltip
                        id={`table`}
                        html={true}
                        multiline={true}
                        getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
                        className="notranslate"
                        backgroundColor="#007bff"
                    />
                    <table
                        className={`table table-common table-min-height ${hasMultiAction ? "sticky-table-otr" : ""} ${
                            lineEditingEnabled && this.props?.lineEditDropdownValue ? "rcm-pjt-height" : ""
                        } ${this.props?.isSurveyAsset ? "asset-icon-lf-table" : ""}`}
                    >
                        <thead>
                            <tr ref={this.setWrapperRef}>
                                {(this.props.match.params.section === "imageInfo" || hasMultiAction || isCRSelection) &&
                                (isAssetSurvey || isRecomSurvey ? hasSelectAll : true) ? (
                                    <th className="img-sq-box seting-type checkbox-container">
                                        <label className="container-checkbox cursor-hand m-0">
                                            <input
                                                type="checkbox"
                                                checked={tableData.data?.length >= 1 && everyItemCheckedPerPage}
                                                onChange={e => handleSelectAllRecom(e.target.checked)}
                                                disabled={this.props?.viewOnly}
                                            />
                                            <span className={`checkmark ${this.props?.viewOnly ? "cursor-disabled" : ""}`}></span>
                                        </label>
                                    </th>
                                ) : (
                                    <th className="img-sq-box seting-type checkbox-container column-sticky-th">
                                        <img alt="" src="/img/sq-box.png" />
                                    </th>
                                )}
                                {tableData.keys &&
                                    tableData.keys.map((keyItem, i) => {
                                        return tableData.config && tableData.config[keyItem] && tableData.config[keyItem].isVisible ? (
                                            <Th
                                                key={`${keyItem}-${i}`}
                                                data-key-item={keyItem}
                                                className={`resize-col-${keyItem} ${updateColumnWidthInConfig ? "pr-24" : ""} ${
                                                    tableData.config[keyItem].class
                                                }${
                                                    (tableParams &&
                                                        tableParams.filters &&
                                                        tableParams.filters[tableData.config[keyItem].searchKey] &&
                                                        tableParams.filters[tableData.config[keyItem].searchKey].key) ||
                                                    (tableParams &&
                                                        tableParams.filters &&
                                                        (tableParams.filters[tableData.config[keyItem].searchKey]?.filters.includes("not_null") ||
                                                            tableParams.filters[tableData.config[keyItem].searchKey]?.filters.includes("null") ||
                                                            tableParams?.filters?.[tableData.config?.[keyItem]?.searchKey]?.filters?.includes("count_gt_1"))) ||
                                                    this.checkHasCommonFilters(
                                                        tableData.config[keyItem].commonSearchKey,
                                                        tableData.config[keyItem].commonSearchObjectKey,
                                                        tableData.config[keyItem].searchKey
                                                    ) ||
                                                    (this.props?.isRecommendationLog &&
                                                        (tableParams?.[tableData.config[keyItem].searchKey]?.length > 0 ||
                                                            (tableParams &&
                                                                tableParams.filters &&
                                                                tableParams.filters[tableData.config[keyItem]?.wildCardkey] &&
                                                                tableParams.filters[tableData.config[keyItem]?.wildCardkey]?.key) ||
                                                            (tableParams &&
                                                                tableParams.filters &&
                                                                (tableParams.filters[tableData.config[keyItem]?.wildCardkey]?.filters.includes(
                                                                    "not_null"
                                                                ) ||
                                                                    tableParams.filters[tableData.config[keyItem]?.wildCardkey]?.filters.includes(
                                                                        "null"
                                                                    )))))
                                                        ? " bg-th-filtered"
                                                        : ""
                                                } ${tableData.config[keyItem]?.pinned ? "pinned" : ""} ${
                                                    keyItem === "asset_survey_status" ? "sticky-asset-th" : ""
                                                } ${viewOnly ? "cursor-disabled" : "cursor-pointer"} `}
                                                ref={ref => {
                                                    if (pinnedColumnsRef) pinnedColumnsRef[keyItem] = ref;
                                                }}
                                                $thStyle={{ ...tableData.config[keyItem]?.style }}
                                            >
                                                <div
                                                    className={`table-item-wrapper ${viewOnly ? "cursor-disabled" : ""}`}
                                                    onClick={event => {
                                                        if (
                                                            !this.state.isResizing &&
                                                            hasSort &&
                                                            config?.[keyItem].hasColumnSort !== false &&
                                                            !viewOnly
                                                        ) {
                                                            this.setSortOrderParams(
                                                                event,
                                                                tableData.config[keyItem].searchKey,
                                                                tableData.config[keyItem].label,
                                                                tableData,
                                                                tableData.config[keyItem]
                                                            );
                                                        }
                                                    }}
                                                >
                                                    <EllipsisTooltipText
                                                        className={`text-line-clamp-2 ${highlightSearchField === keyItem ? "text-goto-active" : ""}`}
                                                        text={tableData.config[keyItem].label}
                                                        tooltipId="table"
                                                    />
                                                    <span id={`thIconsContainer_${tableData.config[keyItem].searchKey}`}>
                                                        {hasPin && (
                                                            <button
                                                                type="button"
                                                                className="close"
                                                                onClick={e => {
                                                                    e.stopPropagation();
                                                                    ReactTooltip.hide();
                                                                    if (!viewOnly) {
                                                                        handleColumnPin(keyItem);
                                                                    }
                                                                }}
                                                            >
                                                                <span
                                                                    className="close-reg cut-close ml-2"
                                                                    data-place="top"
                                                                    data-effect="solid"
                                                                    data-tip={tableData.config[keyItem]?.pinned ? `Unpin Column` : `Pin Column`}
                                                                    data-background-color="#007bff"
                                                                >
                                                                    <i class={`fas fa-thumbtack ${viewOnly ? "cursor-disabled" : ""}`}></i>
                                                                </span>
                                                            </button>
                                                        )}
                                                        {tableData.config[keyItem].hasCommonSearch ? (
                                                            <>
                                                                <span
                                                                    className="close-reg dropdown-toggle"
                                                                    onClick={e => {
                                                                        e.stopPropagation();
                                                                        this.showCommonSearchDropDown(keyItem);
                                                                    }}
                                                                    onMouseDown={e => e.stopPropagation()}
                                                                >
                                                                    <i className="fas fa-chevron-down"></i>
                                                                </span>

                                                                <div onClick={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()}>
                                                                    {this.renderFiltersForCommonSearch(keyItem)}
                                                                </div>
                                                            </>
                                                        ) : hasColumnClose ? (
                                                            <button type="button" className="close" onClick={() => handleHideColumn(keyItem)}>
                                                                <span aria-hidden="true">
                                                                    <img src="/img/close.svg" alt="" />
                                                                </span>
                                                            </button>
                                                        ) : null}

                                                        {tableParams &&
                                                        (isRecommendationLog
                                                            ? tableParams.order && tableParams.order[tableData.config[keyItem].sortKey]
                                                            : tableParams.order && tableParams.order[tableData.config[keyItem].searchKey]) ? (
                                                            <>
                                                                {tableParams.order[tableData.config[keyItem].searchKey] === "asc" ||
                                                                tableParams.order[tableData.config[keyItem].sortKey] === "asc" ? (
                                                                    <i
                                                                        className={`fas fa-long-arrow-alt-up table-param-rep text-danger`}
                                                                        onClick={event => {
                                                                            if (hasSort && config?.[keyItem].hasColumnSort !== false && !viewOnly) {
                                                                                this.setSortOrderParamsByArrow(
                                                                                    event,
                                                                                    tableData.config[keyItem].searchKey,
                                                                                    tableData.config[keyItem].label,
                                                                                    tableData
                                                                                );
                                                                                this.setState({ isResizing: false });
                                                                            }
                                                                        }}
                                                                    ></i>
                                                                ) : (
                                                                    <i
                                                                        className={`fas fa-long-arrow-alt-down table-param-rep text-danger`}
                                                                        onClick={event =>
                                                                            hasSort && config?.[keyItem].hasColumnSort !== false && !viewOnly
                                                                                ? this.setSortOrderParamsByArrow(
                                                                                      event,
                                                                                      tableData.config[keyItem].searchKey,
                                                                                      tableData.config[keyItem].label,
                                                                                      tableData
                                                                                  )
                                                                                : null
                                                                        }
                                                                    ></i>
                                                                )}
                                                            </>
                                                        ) : null}
                                                        {tableParams &&
                                                        tableParams.order &&
                                                        tableParams.maintenance_year &&
                                                        tableParams.maintenance_year.length &&
                                                        keyItem.split("_")[1] == tableParams.maintenance_year[0] ? (
                                                            <>
                                                                {tableParams.order["maintenance_years.amount"] === "asc" ? (
                                                                    <i
                                                                        className={`fas fa-long-arrow-alt-up table-param-rep text-danger`}
                                                                        onClick={event =>
                                                                            hasSort && config?.[keyItem].hasColumnSort !== false && !viewOnly
                                                                                ? this.setSortOrderParamsByArrow(
                                                                                      event,
                                                                                      tableData.config[keyItem].searchKey,
                                                                                      tableData.config[keyItem].label,
                                                                                      tableData
                                                                                  )
                                                                                : null
                                                                        }
                                                                    ></i>
                                                                ) : tableParams.order["maintenance_years.amount"] === "desc" ? (
                                                                    <i
                                                                        className={`fas fa-long-arrow-alt-down table-param-rep text-danger`}
                                                                        onClick={event =>
                                                                            hasSort && config?.[keyItem].hasColumnSort !== false && !viewOnly
                                                                                ? this.setSortOrderParamsByArrow(
                                                                                      event,
                                                                                      tableData.config[keyItem].searchKey,
                                                                                      tableData.config[keyItem].label,
                                                                                      tableData
                                                                                  )
                                                                                : null
                                                                        }
                                                                    ></i>
                                                                ) : null}
                                                            </>
                                                        ) : null}
                                                        {tableParams &&
                                                        tableParams.order &&
                                                        tableParams.index &&
                                                        tableParams.index.length &&
                                                        keyItem.split("t")[2] == tableParams.index[0] ? (
                                                            <>
                                                                {tableParams.order["options.name"] === "asc" ? (
                                                                    <i
                                                                        className={`fas fa-long-arrow-alt-up table-param-rep text-danger`}
                                                                        onClick={event =>
                                                                            hasSort && config?.[keyItem].hasColumnSort !== false && !viewOnly
                                                                                ? this.setSortOrderParamsByArrow(
                                                                                      event,
                                                                                      tableData.config[keyItem].searchKey,
                                                                                      tableData.config[keyItem].label,
                                                                                      tableData
                                                                                  )
                                                                                : null
                                                                        }
                                                                    ></i>
                                                                ) : tableParams.order["options.name"] === "desc" ? (
                                                                    <i
                                                                        className={`fas fa-long-arrow-alt-down table-param-rep text-danger`}
                                                                        onClick={event =>
                                                                            hasSort && config?.[keyItem].hasColumnSort !== false && !viewOnly
                                                                                ? this.setSortOrderParamsByArrow(
                                                                                      event,
                                                                                      tableData.config[keyItem].searchKey,
                                                                                      tableData.config[keyItem].label,
                                                                                      tableData
                                                                                  )
                                                                                : null
                                                                        }
                                                                    ></i>
                                                                ) : null}
                                                            </>
                                                        ) : null}
                                                        {tableParams &&
                                                        tableParams?.priority_elements &&
                                                        tableParams?.priority_elements.length &&
                                                        tableParams?.index &&
                                                        tableParams?.index?.length &&
                                                        Number(keyItem?.split("t")?.[2]) ==
                                                            tableParams?.index[tableParams?.index?.indexOf(Number(keyItem?.split("t")?.[2]))] ? (
                                                            <>
                                                                {(() => {
                                                                    const priorityId = tableData?.config[keyItem]?.keyId;
                                                                    const matchedPriority = tableParams?.priority_elements?.find(
                                                                        p => p?.id === priorityId
                                                                    );
                                                                    return matchedPriority ? (
                                                                        matchedPriority.order === "asc" ? (
                                                                            <i
                                                                                className={`fas fa-long-arrow-alt-up table-param-rep text-danger`}
                                                                                onClick={event =>
                                                                                    hasSort && config?.[keyItem]?.hasColumnSort !== false && !viewOnly
                                                                                        ? this.setSortOrderParamsByArrow(
                                                                                              event,
                                                                                              tableData.config[keyItem].searchKey,
                                                                                              tableData.config[keyItem].label,
                                                                                              tableData
                                                                                          )
                                                                                        : null
                                                                                }
                                                                            ></i>
                                                                        ) : matchedPriority.order === "desc" ? (
                                                                            <i
                                                                                className={`fas fa-long-arrow-alt-down table-param-rep text-danger`}
                                                                                onClick={event =>
                                                                                    hasSort && config?.[keyItem]?.hasColumnSort !== false && !viewOnly
                                                                                        ? this.setSortOrderParamsByArrow(
                                                                                              event,
                                                                                              tableData.config[keyItem].searchKey,
                                                                                              tableData.config[keyItem].label,
                                                                                              tableData
                                                                                          )
                                                                                        : null
                                                                                }
                                                                            ></i>
                                                                        ) : null
                                                                    ) : null;
                                                                })()}
                                                            </>
                                                        ) : null}
                                                    </span>
                                                </div>
                                            </Th>
                                        ) : null;
                                    })}
                                {hasActionColumn && !isBuildingLocked && !isAssignProject ? (
                                    <th
                                        className={`action ${
                                            isReportTemplate
                                                ? "w-action"
                                                : isImportHistory ||
                                                  hasMultiAction ||
                                                  isNewTableFilters ||
                                                  this.props.match.params.tab === "buildingLease"
                                                ? "imp-history-action"
                                                : handleSpecialReportActions ||
                                                  (hasAssignToSpecialReport && hasAssignToReportParagraph && hasAssignToChildParagraph)
                                                ? "wide-action"
                                                : isBudgetPriority
                                                ? "action-wide"
                                                : tableActionClass
                                        } ${isRecommendationLog ? "text-center" : ""}`}
                                    >
                                        Action
                                        {hasPaneView && (
                                            <div
                                                data-tip={paneViewEnabled ? "Disable Details Pane View" : "Enable Details Pane View"}
                                                data-for="pane-view"
                                                className="d-inline hand-cursor"
                                                onClick={() => {
                                                    OnPaneViewClick();
                                                }}
                                            >
                                                {paneViewEnabled ? (
                                                    <img src="/img/Group 16 active.svg" className="ml-1" alt="Pane view" />
                                                ) : (
                                                    <img src="/img/Group 16.svg" className="ml-1" alt="Pane view" />
                                                )}
                                            </div>
                                        )}
                                    </th>
                                ) : null}
                            </tr>
                            <ReactTooltip id="pane-view" effect="solid" backgroundColor="#1383D9" />
                        </thead>
                        <tbody id="common-table-body">
                            {showWildCardFilter ? (
                                !isNewWildCardFilter ? (
                                    <WildCardFilter
                                        noFutureDate={this.props.noFutureDate}
                                        updateWildCardFilter={updateWildCardFilter}
                                        wildCardFilter={wildCardFilter}
                                        hasWildCardOptions={hasWildCardOptions}
                                        hasActionColumn={hasActionColumn}
                                        keys={tableData.keys}
                                        config={tableData.config}
                                        isRecommendationLog={isRecommendationLog}
                                        viewOnly={viewOnly}
                                        showCommonSearchDropDown={this.state?.selectedFieldForCommonSearch}
                                    />
                                ) : (
                                    <NewWildCardFilter
                                        updateWildCardFilter={updateWildCardFilter}
                                        wildCardFilter={wildCardFilter}
                                        hasWildCardOptions={hasWildCardOptions}
                                        hasActionColumn={hasActionColumn}
                                        keys={tableData.keys}
                                        config={tableData.config}
                                        isNewTableFilters={isNewTableFilters}
                                        showCommonSearchDropDown={this.state.selectedFieldForCommonSearch}
                                    />
                                )
                            ) : null}
                            {tableData.data && tableData.data.length ? (
                                <>
                                    {tableData.data.map((dataItem, i) => {
                                        const rowIsActive =
                                            !!isInputMode &&
                                            (isInputMode.rowId
                                                ? isInputMode.rowId === dataItem?.id
                                                : isInputMode.rowIndex === i);
                                        const rowIsLoadingDropdown =
                                            typeof this.props?.isDropdownLoading === "string" &&
                                            this.props.isDropdownLoading.startsWith(`${i}::`);
                                        return (
                                        <Row
                                            key={dataItem?.id}
                                            keys={tableData.keys}
                                            config={tableData.config}
                                            rowData={dataItem}
                                            rowIndex={i}
                                            updateCurrentViewAllUsers={updateCurrentViewAllUsers}
                                            currentViewAllUsers={currentViewAllUsers}
                                            handleDeleteItem={handleDeleteItem}
                                            hasEndTask={hasEndTask}
                                            hasLog={hasLog}
                                            showEditPage={showEditPage}
                                            showInfoPage={showInfoPage}
                                            hasInfoPage={isAssignProject ? false : hasInfoPage}
                                            updateSelectedRow={updateSelectedRow}
                                            selectedRowId={selectedRowId || null}
                                            hasActionColumn={isAssignProject ? false : hasActionColumn}
                                            tableParams={tableParams}
                                            isBuildingLocked={isBuildingLocked}
                                            showRestoreModal={showRestoreModal}
                                            isImportHistory={isImportHistory}
                                            handleDownloadItem={handleDownloadItem}
                                            permissions={permissions}
                                            handleSelect={this.handleSelectRow}
                                            isAssignProject={isAssignProject}
                                            recomentationIds={
                                                this.props.match.params.tab === "recommendations" ||
                                                this.props.match.params.tab === "cr-recommendations"
                                                    ? this.state.idArray
                                                    : this.props.recomentationIds
                                            }
                                            selectedAllClicked={this.props.selectedAllClicked}
                                            hasEdit={hasEdit}
                                            hasDelete={hasDelete}
                                            hasAssignToTrade={hasAssignToTrade}
                                            hasAssignToSystem={hasAssignToSystem}
                                            hasAssignToSubSystem={hasAssignToSubSystem}
                                            handleAssignToTrade={handleAssignToTrade}
                                            handleAssignToSystem={handleAssignToSystem}
                                            handleAssignToSubSystem={handleAssignToSubSystem}
                                            isReportTemplate={isReportTemplate}
                                            handleToggleSlider={handleToggleSlider}
                                            hasExport={hasExport}
                                            handleSelectRecom={handleSelectRecom}
                                            selectedRecomIds={selectedRecomIds}
                                            handleSpecialReportActions={handleSpecialReportActions}
                                            isAssignAsset={this.props.isAssignAsset}
                                            handleSelectAsset={this.props.handleSelectAsset}
                                            selectedAsset={this.props.selectedAsset}
                                            hasAssignToSpecialReport={hasAssignToSpecialReport}
                                            hasAssignToReportParagraph={hasAssignToReportParagraph}
                                            hasAssignToChildParagraph={hasAssignToChildParagraph}
                                            hasMultiAction={hasMultiAction}
                                            handleMultiSelect={handleMultiSelect}
                                            priorityElementsData={priorityElementsData}
                                            isBudgetPriority={isBudgetPriority}
                                            hasViewIcon={this.props.hasViewIcon}
                                            hasTabActive={hasTabActive}
                                            isInputMode={rowIsActive ? isInputMode : null}
                                            handleCellFocus={handleCellFocus}
                                            handleCellValueChange={handleCellValueChange}
                                            lineEditingEnabled={lineEditingEnabled}
                                            isCRSelection={isCRSelection}
                                            isShiftHistory={this.props.isShiftHistory}
                                            getListForCommonFilter={this.props.getListForCommonFilter}
                                            lineEditDropdownValue={rowIsActive ? this.props?.lineEditDropdownValue : null}
                                            lineEditSuggestionValue={rowIsActive ? this.props?.lineEditSuggestionValue : []}
                                            hasPrefixSuggestionMatch={this.props?.hasPrefixSuggestionMatch || false}
                                            isDropdownLoading={rowIsActive || rowIsLoadingDropdown ? this.props?.isDropdownLoading : null}
                                            handleSurveyStatus={this.props.handleSurveyAssetStatus}
                                            isSurveyAsset={this.props?.isSurveyAsset}
                                            clientId={this.props?.clientId}
                                            isRecommendationLog={this.props?.isRecommendationLog || false}
                                            handleChangeDynamicFields={this.props?.handleChangeDynamicFields}
                                            handleChangeDynamicFieldValue={this.props?.handleChangeDynamicFieldValue}
                                            isRecommendationTable={isRecommendationTable}
                                            hasSurveyAssign={hasSurveyAssign}
                                            handleSurveyAssign={handleSurveyAssign}
                                            assignedRows={assignedRows}
                                            initialSelectedAssets={initialSelectedAssets}
                                            viewOnly={this.props?.viewOnly || false}
                                            isAssetMngView={this.props?.isAssetMngView || false}
                                            isAssetSurvey={isAssetSurvey}
                                            selectedMultiRow={selectedMultiRow}
                                            disableRowClickBreadcrumb={disableRowClickBreadcrumb}
                                            isSurveyRecom={this.props?.isSurveyRecom ?? false}
                                            isRecomSurvey={isRecomSurvey}
                                            isSurveybasedRecoms={isSurveybasedRecoms}
                                            tableDataList={tableData?.data??[]}
                                            hasErrorLog={hasErrorLog}
                                            hasViewLog={hasViewLog}
                                            hasDownloadLog={hasDownloadLog}
                                            findAndReplaceParams={findAndReplaceParams}
                                        />
                                        );
                                    })}
                                    <SummaryRow
                                        keys={tableData.keys}
                                        config={tableData.config}
                                        tableData={tableData}
                                        tableParams={tableParams}
                                        summaryRowData={summaryRowData}
                                    />
                                    <SummaryRowEnergy
                                        keys={tableData.keys}
                                        config={tableData.config}
                                        tableData={tableData}
                                        tableParams={tableParams}
                                        summaryRowData={summaryRowDataEnergy}
                                    />
                                </>
                            ) : (
                                <tr className="text-center">
                                    {tableData.keys.map(keyItem => {
                                        if (tableData.config && tableData.config[keyItem]?.isVisible) {
                                            columnCount += 1;
                                        }
                                    })}
                                    <td className="noRecordsColumn" colSpan={columnCount}>
                                        No records found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </LoadingOverlay>
        );
    }
}

const GroupByFilter = ({ options, keyItem, selectedValues = [], setCommonFilterParams, getCapitalTypeData, isSurveyAsset = false }) => {
    const groupedOptions = Object.entries(
        options.reduce((groups, item) => {
            const groupName = item.group || "Others";
            if (!groups[groupName]) {
                groups[groupName] = { items: [], totalCount: 0 };
            }
            groups[groupName].items.push(item);
            groups[groupName].totalCount += +item.count || 0;
            return groups;
        }, {})
    )?.sort(([groupNameA], [groupNameB]) => {
        return (groupNameA === "Others") - (groupNameB === "Others") || groupNameA?.localeCompare(groupNameB);
    });

    const toggleGroup = groupItems => {
        groupItems.forEach(item => {
            setTimeout(() => {
                setCommonFilterParams(keyItem, item);
            }, 1);
        });
    };
    const filterData = selectedValues.map(item => item.id);
    if (!options.length) {
        return <div className="col-md-6 no-wrap">NO DATA</div>;
    }
    return (
        <div className="col-md-12 p-0 slt-ara">
            {groupedOptions.map(([groupName, groupData], idx) => {
                const { items: groupItems, totalCount } = groupData;
                const isGroupSelected = groupItems.every(item => filterData.includes(item.id));
                return (
                    <>
                        {idx > 0 ? <hr /> : null}
                        <div key={groupName} className="group-section">
                            <div className="container-check group-title d-flex align-items-center mb-2">
                                <label class="">
                                    <input type="checkbox" checked={isGroupSelected} onChange={() => toggleGroup(groupItems, !isGroupSelected)} />
                                    <span class="checkmark"></span>
                                </label>
                                <span class="ml-1 text-short top-head">{groupName}</span>
                                <span className="count-num"> ({totalCount})</span>
                            </div>
                            {groupItems?.map((item, i) => (
                                <span key={i} className="dropdown-item notranslate">
                                    <ReactTooltip id="building-dropdown" />
                                    {item.name !== null && item.name !== "" ? (
                                        <FilterItem
                                            item={item}
                                            keyItem={keyItem}
                                            getCapitalTypeData={getCapitalTypeData}
                                            setCommonFilterParams={setCommonFilterParams}
                                            checked={filterData.includes(item.id)}
                                            isSurveyAsset={isSurveyAsset}
                                        />
                                    ) : null}
                                </span>
                            ))}
                        </div>
                    </>
                );
            })}
        </div>
    );
};

export const FilterItem = React.memo(
    ({ item, keyItem, setCommonFilterParams, getCapitalTypeData, checked, viewOnly = false, isSurveyAsset = false, fieldConfig = {} }) => {
        const labelText = useMemo(() => {
            let text;

            if (keyItem === "capital_type") {
                text = getCapitalTypeData(item.name);
            } else if (item.name === true || item.name === "yes") {
                text = "Yes";
            } else if (item.name === false || item.name === "no") {
                text = "No";
            } else if (keyItem === "source" && fieldConfig?.miscellaneous) {
                text = formatCapitalRequestSourceValue(String(item.name), fieldConfig.miscellaneous);
            } else if (fieldConfig?.formatFilterLabel) {
                text = fieldConfig.formatFilterLabel(item.name);
            } else {
                text = String(item.name);
            }

            const { appendColumnKey } = fieldConfig;
            if (appendColumnKey && item[appendColumnKey]) {
                text += ` (${item[appendColumnKey]})`;
            } else if (item.description) {
                text += ` (${item.description})`;
            }

            return isSurveyAsset ? removeAllTags(text) : text;
        }, [keyItem, item, getCapitalTypeData, fieldConfig, isSurveyAsset]);

        const handleChange = () => {
            if (!viewOnly) {
                setCommonFilterParams(keyItem, item);
            }
        };

        return (
            <label className={`container-check d-flex align-items-center${viewOnly ? " cursor-disabled" : ""}`}>
                <EllipsisTooltipText className="text-short" text={labelText} />
                <span className="count-num">({item.count})</span>
                <input type="checkbox" checked={checked} onChange={handleChange} disabled={viewOnly} />
                <span className="checkmark" />
            </label>
        );
    }
);

export default withRouter(Table);
